<nb-user
  *ngIf="mode == 'avatar'"
  [picture]="imageURL"
  onlyPicture
  [size]="size"
  (click)="viewProfile()"
  class="link"
></nb-user>

<nb-user
  *ngIf="mode == 'icon'"
  [name]="shortName"
  onlyPicture
  [size]="size"
  color="#ffffff"
  (click)="viewProfile()"
  class="link"
></nb-user>

<a *ngIf="mode == 'name'" (click)="viewProfile()" class="link">
  <nb-icon *ngIf="icon && icon != ''" [icon]="icon"></nb-icon>
  <strong>
    {{ name }}
  </strong>
</a>
